import Constants from '../actions/types';

// const initialState = {
//   loggedIn: true,
//   user: {
//     first_name: 'Shen',
//     last_name: 'Zhi',
//     email: 'demo@devias.io',
//     avatar: '/images/avatars/avatar_11.png',
//     bio: 'Brain Director',
//     role: 'ADMIN' // ['GUEST', 'USER', 'ADMIN']
//   }
// };
// const defaultUser = {
//   role: 'GUEST',
//   first_name: 'Odysseas',
//   last_name: 'Pentakalos'
// };

const initialState = {
  authenticating: false,
  loggedIn: false,
  user: {}
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.LOGIN_REQUEST: {
      const newState = {
        authenticating: true,
        loggedIn: false,
        user: {}
      };

      return newState;
    }

    case Constants.LOGIN_SUCCESS: {
      const newState = {
        authenticating: false,
        loggedIn: true,
        sessionId: action.payload.sessionId,
        user: action.payload.user
      };

      return newState;
    }

    // If we reloaded a user account and happens to be
    // the account of the currently logged in user
    // then update the data on the client
    case Constants.USER_GET_SUCCESS: {
      const newState =
        state.user.id === action.payload.id
          ? {
              ...state,
              user: action.payload
            }
          : state;

      return newState;
    }

    case Constants.LOGIN_FAILURE: {
      const newState = {
        authenticating: false,
        error: action.payload,
        loggedIn: false,
        user: {}
      };

      return newState;
    }

    case Constants.LOGIN_CLEARERROR: {
      const newState = {
        ...state,
        error: null
      };

      return newState;
    }

    case Constants.SESSION_LOGOUT: {
      return {
        authenticating: false,
        loggedIn: false,
        user: {
          role: 'GUEST'
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
